import { render, staticRenderFns } from "./CreateGoogleBusinessChannel.vue?vue&type=template&id=d6e99ddc&scoped=true"
import script from "./CreateGoogleBusinessChannel.vue?vue&type=script&lang=js"
export * from "./CreateGoogleBusinessChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateGoogleBusinessChannel.vue?vue&type=style&index=0&id=d6e99ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e99ddc",
  null
  
)

export default component.exports